import React from 'react'
import './StockSidebar.css'

/**
 * 무료 스톡 이미지 사이드바
 */
function StockSidebar({ 
  searchSettings, 
  setSearchSettings, 
  savedCount = 0,
  onClearCache,
  cacheInfo
}) {
  return (
    <div className="stock-sidebar">
      <div className="stock-sidebar-header">
        <h3>스톡 이미지 설정</h3>
      </div>
      
      <div className="stock-sidebar-content">
        <div className="sidebar-section">
        <h3 className="section-title">검색 설정</h3>
        
        <div className="form-group">
          <label>이미지 크기</label>
          <select 
            value={searchSettings?.size || 'large'}
            onChange={(e) => setSearchSettings({...searchSettings, size: e.target.value})}
            className="form-select"
          >
            <option value="original">원본 (최고 품질)</option>
            <option value="large2x">매우 큼 (2x)</option>
            <option value="large">큼 (기본)</option>
            <option value="medium">중간</option>
            <option value="small">작음</option>
          </select>
        </div>

        <div className="form-group">
          <label>이미지 방향</label>
          <select 
            value={searchSettings?.orientation || 'all'}
            onChange={(e) => setSearchSettings({...searchSettings, orientation: e.target.value})}
            className="form-select"
          >
            <option value="all">모든 방향</option>
            <option value="landscape">가로</option>
            <option value="portrait">세로</option>
            <option value="square">정사각형</option>
          </select>
        </div>

        <div className="form-group">
          <label>검색 결과 수</label>
          <select 
            value={searchSettings?.perPage || 30}
            onChange={(e) => setSearchSettings({...searchSettings, perPage: parseInt(e.target.value)})}
            className="form-select"
          >
            <option value="15">15개</option>
            <option value="30">30개</option>
            <option value="50">50개</option>
            <option value="80">80개</option>
          </select>
        </div>

        <div className="form-group">
          <label>색상 필터</label>
          <div className="color-filters">
            {[
              { value: 'red', label: '빨강', color: '#FF0000' },
              { value: 'orange', label: '주황', color: '#FFA500' },
              { value: 'yellow', label: '노랑', color: '#FFFF00' },
              { value: 'green', label: '초록', color: '#008000' },
              { value: 'turquoise', label: '청록', color: '#40E0D0' },
              { value: 'blue', label: '파랑', color: '#0000FF' },
              { value: 'violet', label: '보라', color: '#8B00FF' },
              { value: 'pink', label: '분홍', color: '#FFC0CB' },
              { value: 'brown', label: '갈색', color: '#964B00' },
              { value: 'black', label: '검정', color: '#000000' },
              { value: 'gray', label: '회색', color: '#808080' },
              { value: 'white', label: '흰색', color: '#FFFFFF' }
            ].map(colorOption => (
              <button
                key={colorOption.value}
                className={`color-filter-btn ${searchSettings?.color === colorOption.value ? 'active' : ''}`}
                onClick={() => setSearchSettings({
                  ...searchSettings, 
                  color: searchSettings?.color === colorOption.value ? null : colorOption.value
                })}
                style={{ backgroundColor: colorOption.color }}
                title={colorOption.label}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">카테고리</h3>
        <div className="category-list">
          {[
            { id: 'nature', label: '자연', icon: '🌿' },
            { id: 'people', label: '사람', icon: '👥' },
            { id: 'animals', label: '동물', icon: '🐾' },
            { id: 'food', label: '음식', icon: '🍽️' },
            { id: 'travel', label: '여행', icon: '✈️' },
            { id: 'business', label: '비즈니스', icon: '💼' },
            { id: 'technology', label: '기술', icon: '💻' },
            { id: 'architecture', label: '건축', icon: '🏛️' },
            { id: 'fashion', label: '패션', icon: '👗' },
            { id: 'sports', label: '스포츠', icon: '⚽' },
            { id: 'health', label: '건강', icon: '💪' },
            { id: 'education', label: '교육', icon: '📚' }
          ].map(category => (
            <button
              key={category.id}
              className={`category-btn ${searchSettings?.category === category.id ? 'active' : ''}`}
              onClick={() => setSearchSettings({
                ...searchSettings,
                category: searchSettings?.category === category.id ? null : category.id
              })}
            >
              <span className="category-icon">{category.icon}</span>
              <span className="category-label">{category.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">저장 관리</h3>
        <div className="stats-card">
          <div className="stat-item">
            <span className="stat-label">저장된 이미지</span>
            <span className="stat-value">{savedCount}개</span>
          </div>
        </div>
      </div>

      {cacheInfo && (
        <div className="sidebar-section">
          <h3 className="section-title">캐시 정보</h3>
          <div className="cache-info">
            <p className="cache-text">캐시된 검색: {cacheInfo.count}개</p>
            <p className="cache-text">캐시 크기: {cacheInfo.size}</p>
            <button 
              className="clear-cache-btn"
              onClick={onClearCache}
            >
              캐시 비우기
            </button>
          </div>
        </div>
      )}

      <div className="sidebar-section">
        <h3 className="section-title">사용 팁</h3>
        <div className="tips-box">
          <p className="tip">💡 영어로 검색하면 더 많은 결과를 얻을 수 있습니다</p>
          <p className="tip">💡 색상 필터를 사용하여 원하는 분위기의 이미지를 찾아보세요</p>
          <p className="tip">💡 저장한 이미지는 프로젝트에서 계속 사용할 수 있습니다</p>
        </div>
      </div>

        <div className="sidebar-footer">
          <p className="attribution">
            Powered by <a href="https://www.pexels.com" target="_blank" rel="noopener noreferrer">Pexels</a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default StockSidebar